// PROF-1 — la PRIMA riga `PROFILE` di chi è appena entrato su invito.
//
// ⛔ Vive qui, e non nei due montaggi, perché è **una decisione di prodotto in
// tre righe** e le decisioni non si scrivono due volte: quale campo è
// obbligatorio, che la scrittura è diretta e non get-merge, e cosa succede se
// fallisce. Scritta nei due `WelcomeGate` sarebbe stata la solita coppia che
// diverge appena uno dei due cambia idea.
//
// ⛔ **PUT diretta, mai gli sportelli get-merge-PUT** (`useProfileDoc.savePatch`
// / `patchProfile`): rileggono il documento prima di fondere, e qui il
// documento **non esiste ancora** — misurato l'1/09, la GET risponde 404. La
// PUT lato API è create-or-update, quindi la riga nasce da questa sola chiamata.
//
// ⚠️ `name` è l'unico campo dello schema senza default (`schemas/profile.ts`):
// `unitsPreference` e gli altri li riempie zod. Per questo il form chiede il
// nome e nient'altro.

/** Il minimo che serve: la firma che entrambi i mount già espongono.
 *  ⛔ `method` è il letterale "PUT", non `string`: i due `apiFetch` tipizzano
 *  il verbo come unione chiusa, e allargarlo qui li renderebbe non assegnabili.
 *  È anche più onesto — questa funzione fa una cosa sola. */
type ProfileWriter = (
  path: string,
  opts: { method: "PUT"; body: unknown },
) => Promise<unknown>;

/**
 * Crea la riga profilo. ⛔ NON rilancia: un fallimento qui non deve rimandare
 * indietro chi è appena entrato — la sfida Cognito è già chiusa e la password
 * temporanea non apre più niente, quindi «torna alla porta» manderebbe l'atleta
 * a una porta murata. Restituisce l'esito così che chi chiama possa dirlo,
 * invece di scoprirlo da un `console.warn` che non legge nessuno.
 */
export const createInitialProfile = async (
  apiFetch: ProfileWriter,
  name: string,
): Promise<{ ok: true } | { ok: false; error: unknown }> => {
  try {
    await apiFetch("/api/profiles", { method: "PUT", body: { name } });
    return { ok: true };
  } catch (error) {
    return { ok: false, error };
  }
};
